import { render, staticRenderFns } from "./ReportEditor.vue?vue&type=template&id=6b47fa04&"
import script from "./ReportEditor.vue?vue&type=script&lang=js&"
export * from "./ReportEditor.vue?vue&type=script&lang=js&"
import style0 from "./ReportEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports